import React from 'react';
import './ChatBubble.css';

const ChatBubble = ({ sender, message, className = '' }) => {
  if (!message || (!message.text && !message.displayText)) return null;

  const isAssistant = sender === 'assistant';
  const senderName = isAssistant ? 'NAINA' : 'You';
  const content = message.displayText || message.text;

  return (
    <div className={`chat-bubble ${sender} ${className}`}>
      <div className="sender-name">{senderName}</div>
      <div 
        className="bubble-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ChatBubble;